import axiosInstance from 'api/axiosInstance';
import { URL_CANDISPATCH_READ_ADDRESSES } from 'constants/urls';

interface AddressFilters {
  CustomerId: number;
  SearchKeyword?: string;
  Page?: number;
  Take?: number;
  ShowDeactivated?: boolean;
}

const getAddresses = async (filters: AddressFilters) => {
  const payload = {
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 1000,
    ShowDeactivated: true,
    ...filters,
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANDISPATCH_READ_ADDRESSES}?payload=${JSON.stringify(payload)}`,
      { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, data: null },
    );
    return data;
  } catch (error) {
    console.error('[getAddresses] Failed:', error);
    throw error;
  }
};

export default getAddresses;
